import React from "react";
import {FluentCRMTag} from "../../../../providers/fluentCRM/FluentCRMTypes";

interface BulkTagSyncReportProps {
    created: FluentCRMTag[];
    existing: FluentCRMTag[];
    failed: { title: string; error: string }[];
}

export function BulkTagSyncReport({
                                      created,
                                      existing,
                                      failed,
                                  }: BulkTagSyncReportProps) {
    return (
        <div className="space-y-6">
            {/* Created */}
            <div>
                <h3 className="text-lg font-semibold text-green-700">Created</h3>
                {created.length > 0 ? (
                    <ul className="mt-2 list-disc list-inside space-y-1 text-green-600">
                        {created.map((tag) => (
                            <li key={tag.id}>{tag.title}</li>
                        ))}
                    </ul>
                ) : (
                    <p className="mt-2 text-sm text-gray-500">No new tags created.</p>
                )}
            </div>

            {/* Existing */}
            <div>
                <h3 className="text-lg font-semibold text-blue-700">Existing</h3>
                {existing.length > 0 ? (
                    <ul className="mt-2 list-disc list-inside space-y-1 text-blue-600">
                        {existing.map((tag) => (
                            <li key={tag.id}>{tag.title}</li>
                        ))}
                    </ul>
                ) : (
                    <p className="mt-2 text-sm text-gray-500">No existing tags found.</p>
                )}
            </div>

            {/* Failed */}
            <div>
                <h3 className="text-lg font-semibold text-red-700">Failed</h3>
                {failed.length > 0 ? (
                    <ul className="mt-2 space-y-2">
                        {failed.map((f, idx) => (
                            <li
                                key={idx}
                                className="rounded-md border border-red-200 bg-red-50 p-2 text-sm text-red-600"
                            >
                                <span className="font-medium">{f.title}:</span> {f.error}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="mt-2 text-sm text-gray-500">No failures 🎉</p>
                )}
            </div>
        </div>
    );
}
